// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"wifi-1"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M21.9958 7.50495L11.9998 20L2.00391 7.50509C7.83088 2.83177 16.1687 2.83156 21.9958 7.50495Z","strokeWidth":"props.strokeWidth"}}]}]};

const Wifi1Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'wifi-1',
    ref,
    icon: element,
  },
));

Wifi1Icon.displayName = 'Wifi1Icon';

export default Wifi1Icon;
